<template>
	<div id="fullWidthContent" :style="'min-height:' + this.$parent.height + 'px'">
		<div id="narrow-content">
			<h1 class="bigger-title">Three Degrees</h1>
			<b-row class="mt-5">
				<b-col lg="5" md="5" sm="12">
					<b-img fluid :src="require('@/assets/landing.png')" />
				</b-col>
				<b-col lg="7" md="7" sm="12">
					<div style="text-align: justify">
						<h1 class="centered">
							Welcome to the Future of Living
						</h1>
						<p class="bit-more-margin-top">A members-only network of homes to rent and swap in cities around the world. </p>
						<p>Three Degrees connects you with friends and friends of friends to help you find exceptional homes. We think everyone should be able to rent from a network they can trust, without sacrificing on style. Which is why we vet everyone who applies to our community, so you don't have to.  It's renting, just done better.</p>
						<p>So, whether you are looking for a home, have a home or room to rent, or just curious to take a look in to our world, apply today. Renters & owners welcome.</p>
						<b-row class="mt-4 centered">

							<b-col>
								<div class="dl mt-3 mb-4">
									<h2>iOS</h2>
									<p class="small centered">Mobile</p>
									<a href="https://apps.apple.com/uk/app/three-degrees/id6467742434"><b-img height="60" :src="require('../assets/ios.svg')" /></a>
								</div>
							</b-col>
				
							<b-col>
								<div class="dl mt-3">
									<h2>Android</h2>
									<p class="small centered">Mobile</p>
									<a href="https://s3.eu-west-2.amazonaws.com/www.threedegrees.world/app-release.apk"><b-img height="60" :src="require('../assets/android-dd.png')" /></a>
								</div>
							</b-col>

						</b-row>
					</div>
				</b-col>
			</b-row>
			<div class="centered mt-5 mb-5">
				<a target="_blank" href="https://www.instagram.com/three_degrees_"><b-icon icon="instagram"></b-icon> Follow us @three_degrees_</a>
			</div>
			<div class="centered mt-5 mb-5">
				<a v-b-modal="'appModal'" class="desktopButton"><b-icon icon="globe"></b-icon> Open Desktop Version</a>
			</div>
		</div>
		<b-modal id="appModal" title="Three Degrees" centered  ok-only style="width:450px;">
			<template #modal-header="{ close }">
				<!-- Emulate built in modal header close button action -->
				<b-button style="display:none" size="sm" variant="outline-danger" @click="close()">
					Close Modal
				</b-button>
				<h5 style="display:none">Modal Header</h5>
			</template>
			<iframe style="padding: 0px; border:0px; overflow-y: hidden" height="750" width="100%" src="/#/home">
			</iframe>
			<template #modal-footer="{ close }">
				<!-- Emulate built in modal header close button action -->
				<b-button style="display:none" size="sm" variant="outline-danger" @click="close()">
					Close Modal
				</b-button>
				<h5 style="display:none">Modal Header</h5>
			</template>
		</b-modal>
	</div>
	
</template>

<script>

export default {
	name: "Welcome",
	metaInfo() {
        return { 
            title: "Three Degrees - Welcome",
        }
    },
	data() {
		return {
			
		};
	},	
	methods: {
		
		onLoad: function () {
			
		},

		openApp: function() {
			window.open();
		}

	},
	mounted: function () {
		this.onLoad();
	}
};
</script>

<style scoped>

#app
{
	background-color: #D7D1C4 !important;
}

@media all and (max-width: 600px)
{
	.desktopButton {
		display:none;
	}
}

/deep/ #appModal > .modal-dialog > .modal-content > .modal-header {
	display:none !important;
}

/deep/ #appModal > .modal-dialog > .modal-content > .modal-footer {
	display:none !important;
}

/deep/ #appModal > .modal-dialog > .modal-content > .modal-body {
	padding: 0px;
}

</style>
